import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights, ITelemetryPlugin } from '@microsoft/applicationinsights-web'

import { initAppInsightsLogger } from '@/lib/logger'

const appInsightsConnString = import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING
const appInsightsPlugin = new ReactPlugin()
let appInsightsInstance: ApplicationInsights | null = null

const loadAppInsights = () => {
  if (appInsightsConnString.length) {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: appInsightsConnString,
        extensions: [appInsightsPlugin as unknown as ITelemetryPlugin],
        enableAutoRouteTracking: true,
        autoTrackPageVisitTime: true,
      },
    })

    appInsights.loadAppInsights()
    appInsightsInstance = appInsights

    // Initialize logger with Application Insights
    initAppInsightsLogger(appInsights)
  }
}

export { appInsightsInstance, appInsightsPlugin, loadAppInsights }
